import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { MachineStatisticOEETeep } from '@interfaces/machines';
import BlockWrapper from '@v2/pages/machines/modules/now/components/Overview/components/BlockWrapper';
import { TourTarget } from '@components/tours';
import { WELCOME_TOUR_IDS } from '@components/tours/config/global/welcome/constants';
import { getOEEEffectivenessLabel } from '@components/machines/components/Utilization/components/chart/components/helpers';
import { useManageOeeTodayBlock } from './hooks/useManageOeeTodayBlock';
import { formatOEENumber } from '@helpers';
import { OEE_TOOLS_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { ActionArrow } from '@components/common/ActionArrow';
import { role } from '@components/frame';
import { isRestrictedForOperator, RESTRICTION_CATEGORIES } from '@config/operatorRestrictions';
import { WithColor } from '@styles/colors';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OeeTodayBlockProps extends WithColor {
  oeeTeepData: MachineStatisticOEETeep | null;
}

const OeeTodayBlock: FC<OeeTodayBlockProps> = ({ C, oeeTeepData }) => {
  const isHidden = isRestrictedForOperator(role, RESTRICTION_CATEGORIES.LIVE_OVERVIEW_HIDDEN, 'OeeTodayBlock');
  const { handlePress } = useManageOeeTodayBlock();

  if (isHidden) return null;

  const oeeValue = oeeTeepData?.oee;
  const effectiveness = getOEEEffectivenessLabel(oeeValue);
  const oeePercent = oeeValue != null ? `${formatOEENumber(oeeValue * 100)}%` : '--';

  const {gapBetweenLines,} = OEE_TOOLS_BLOCK_CONFIG;

  return (
    <TourTarget tourId={WELCOME_TOUR_IDS.LIVE_OEE_BLOCK} style={{ flex: 1 }}>
    <BlockWrapper
      testID={TEST_IDS.liveScreen.oeeBlock}
      onPress={handlePress}
      containerStyle={{
        flex: 1,
        paddingTop: scale(14),
        paddingBottom: scale(16),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <View style={{gap: scale(gapBetweenLines)}}>
        <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('OEE Today')}</Text>
        <View style={{ flexDirection: 'row', alignItems: 'baseline', gap: scale(8), marginTop: scale(4) }}>
          <Text style={[font['Large Title'], { color: effectiveness ? C(effectiveness.color) : C('Label/Light/Primary') }]}>{oeePercent}</Text>
          {effectiveness && <Text style={[font['Subhead 2'], { color: C(effectiveness.color) }]}>{effectiveness.label}</Text>}
        </View>
      </View>
      <ActionArrow stylesToReplace={{}} />
    </BlockWrapper>
    </TourTarget>
  );
};

export { OeeTodayBlock };
